import React, { useState } from "react";
import { toast } from "sonner";
import { Euro, Loader2, Save } from "lucide-react";
import { savePrices } from "../../lib/prenotazioniApi";

const ROWS = [
  ["spa_weekday_day", "Spa · giorno · Lun–Ven", "a persona"],
  ["spa_weekend_day", "Spa · giorno · Sab–Dom", "a persona"],
  ["spa_monthu_night", "Spa · notte 21–24 · Lun–Gio", "a persona"],
  ["spa_frisun_night", "Spa · notte 21–24 · Ven–Dom", "a persona"],
  ["massage", "Massaggio · 1 ora", "a trattamento"],
];

export function PricesPanel({ prices, onSaved }) {
  const [v, setV] = useState(prices);
  const [busy, setBusy] = useState(false);
  const dirty = ROWS.some(([k]) => Number(v[k]) !== Number(prices[k]));
  const save = async () => {
    if (!window.confirm("Confermi i nuovi prezzi? Valgono subito anche per le prenotazioni online dei clienti.")) return;
    setBusy(true);
    try { const r = await savePrices(Object.fromEntries(ROWS.map(([k]) => [k, Number(v[k])]))); toast.success("Prezzi aggiornati"); onSaved(r.prices); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-[#e8dcc8] bg-white p-4 space-y-3 max-w-lg" data-testid="prices-panel">
      <div className="font-bold text-sm inline-flex items-center gap-2 text-[#2b1410]"><Euro className="h-4 w-4 text-[#C48B31]" /> Prezzi Spa e Massaggi</div>
      <p className="text-xs text-[#7c5a4e]">Le chiusure (giornate o fasce non prenotabili) si fanno direttamente dalla griglia: tocca una casella libera → "Chiudi fascia" o "Chiudi giornata".</p>
      {ROWS.map(([k, label, unit]) => (
        <label key={k} className="flex items-center gap-3">
          <span className="flex-1 text-sm text-[#2b1410]">{label} <span className="text-[11px] text-[#9a8070]">({unit})</span></span>
          <span className="inline-flex items-center gap-1 text-sm">€ <input type="number" min={1} max={1000} value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} className="w-20 h-10 rounded-xl border border-[#e8dcc8] px-2 text-right font-bold" data-testid={`price-${k}`} /></span>
        </label>
      ))}
      <button onClick={save} disabled={!dirty || busy} className="w-full h-12 rounded-2xl bg-[#4a1c17] text-white font-bold disabled:opacity-40 inline-flex items-center justify-center gap-2" data-testid="prices-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Salva prezzi</button>
    </div>
  );
}
